const GTM_ID = 'GTM-NDFDKF4'

const isProduction = ['production', 'prod'].includes(import.meta.env.VITE_ENVIRONMENT ?? '')

const enable = isProduction && window.location.hostname !== 'localhost'

export function gtagInit(): void {
  if (!enable) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({event: 'gtm.js', 'gtm.start': new Date().getTime()})

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
  document.head.appendChild(script)
}

export function gtagTrackPageView(pagePath: string): void {
  if (!enable) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'page_view',
    page_location: window.location.origin + pagePath,
    page_path: pagePath,
    page_title: document.title
  })
}

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[]
  }
}
